import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { CONSTANT } from '../../../../utils/constants';
import { saveSession } from '../../../../utils/sessionHelper';
import NavbarItem from './NavbarItem';
import { LogOut, ChevronsLeft } from 'lucide-react';
import styles from './Navigation.module.scss';


function Navbar({ isAdmin, availableApps = [] }) {
  const navigate = useNavigate();
  const { accountContext, setAccountContext } = useAccountContext();
  const { navigationContext, setNavigationContext, toggleSidebar } = useNavigationContext();
  const isOpen = navigationContext.isSidebarOpen;

  const handleSignOut = () => {
    setAccountContext(null);
    saveSession(null);
    navigate('/');
  };

  const navigateToApp = (app) => {
    setNavigationContext((prev) => ({
      ...prev,
      activeAppKey: app.key,
      activeProgramId: undefined,
      activeResourceId: undefined
    }));
  };

  const filteredApps = useMemo(() => {
    return CONSTANT[accountContext.scope.slug].apps.filter((a) => {
      return availableApps.some((app) => {
        return app.slug === a.key;
      });
    });
  }, [availableApps]);

  const appList = isAdmin ? filteredApps : CONSTANT[accountContext.scope.slug].apps;

  return (
    <div className={styles.navbar} style={{ maxWidth: isOpen ? '250px' : 'fit-content', minWidth: isOpen ? '250px' : 'fit-content' }}>
      <div className={styles.topContainer}>
        <div className={styles.scopeContainer}>
          <div
            className={styles.scopeLogoContainer}
            style={{ backgroundColor: CONSTANT[accountContext.scope.slug].scopeColor }}
          >
            <img
              className={styles.scopeLogo}
              src={accountContext.scope.logo}
              alt={`logo de ${accountContext.scope.label}`}
            />
          </div>
          {isOpen &&
            <span
              className={styles.scopeLabel}>
              {accountContext.scope.label}
            </span>}
        </div>
        <div className={styles.appList}>
          {appList.map((app) => (
            <NavbarItem
              key={app.key}
              icon={app.icon}
              label={app.label}
              handleNavigation={() => navigateToApp(app)}
              isActive={navigationContext.activeAppKey === app.key}
              isOpen={isOpen}
            />
          ))}
        </div>

      </div>
      <div className={styles.bottomContainer} style={{ alignItems: isOpen ? 'flex-start' : 'center' }}>
        <div onClick={handleSignOut} className={styles.logoutContainer}>
          <LogOut className={styles.navbarItemIcon} />
          {isOpen && <p>Se déconnecter</p>}
        </div>
        <p className={styles.versionContainer}>
          <span>{isOpen ? "Version " : "v "}</span>
          <span>{CONSTANT.version}</span>
        </p>

      </div>

      <button
        onClick={toggleSidebar}
        className={styles.toggleSidebar}
        style={{ rotate: isOpen ? "0deg" : "180deg" }}
        aria-label={isOpen ? "Réduire le menu" : "Élargir le menu"}
      >
        <ChevronsLeft />
      </button>
    </div>
  );
}

export default Navbar;
